import { Link, Outlet, useNavigate, useRouterState } from "@tanstack/react-router";

import { api, type Me } from "../lib/api";
import { setThemePref } from "../lib/theme";
import { authedRoute } from "../main";

// Shell do portal — cópia do layout do Valquiria (routes/_authed.tsx): sidebar
// 220px, placa da marca (só Carmillion), nav, rodapé com conta + tema + sair.

function NavItem({ to, icon, label, active }: { to: string; icon: React.ReactNode; label: string; active: boolean }) {
  return (
    <Link to={to} style={{
      display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 8, fontSize: 14, width: "100%", textAlign: "left",
      textDecoration: "none", transition: "background .1s, color .1s",
      background: active ? "var(--brand-soft)" : "transparent", color: active ? "var(--brand)" : "var(--ink-muted)", fontWeight: active ? 500 : 400,
    }}
      onMouseEnter={(e) => { if (!active) { e.currentTarget.style.background = "var(--surface-hover)"; e.currentTarget.style.color = "var(--ink)"; } }}
      onMouseLeave={(e) => { if (!active) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--ink-muted)"; } }}>
      <span style={{ opacity: active ? 1 : 0.7, display: "flex" }}>{icon}</span>{label}
    </Link>
  );
}

const ico = { width: 18, height: 18, flexShrink: 0 } as const;
const IconAgentes = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={ico}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" /></svg>;
const IconConexoes = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={ico}><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" /></svg>;
const IconUser = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" /></svg>;
const IconTheme = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>;
const IconLogout = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>;

const iconBtn: React.CSSProperties = { background: "transparent", border: "none", color: "var(--ink-muted)", cursor: "pointer", padding: 6, borderRadius: 6, display: "flex" };

export function Layout() {
  const { me } = authedRoute.useRouteContext() as { me: Me };
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const nav = useNavigate();
  const isAgentes = pathname === "/" || pathname.startsWith("/agentes");

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: "var(--surface-app)" }}>
      <aside style={{ width: 220, background: "var(--surface-sidebar)", borderRight: "1px solid var(--line)", display: "flex", flexDirection: "column", flexShrink: 0 }}>
        <div style={{ padding: "14px 12px", borderBottom: "1px solid var(--line)" }}>
          <div style={{ display: "flex", alignItems: "center", background: "var(--logo-plate)", borderRadius: 8, padding: "10px 12px" }}>
            <img src="/logo-carmillion.avif" alt="Carmillion" style={{ height: 22, width: "auto", objectFit: "contain" }} />
          </div>
        </div>
        <nav style={{ flex: 1, padding: "12px 8px", display: "flex", flexDirection: "column", gap: 2 }}>
          <NavItem to="/" icon={<IconAgentes />} label="Agentes" active={isAgentes} />
          <NavItem to="/conexoes" icon={<IconConexoes />} label="Conexões" active={pathname.startsWith("/conexoes")} />
        </nav>
        <div style={{ padding: "12px 8px", borderTop: "1px solid var(--line)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 4px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, minWidth: 0, padding: "4px 8px", color: "var(--ink-muted)" }}>
              <IconUser /><span style={{ fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{me.name}</span>
            </div>
            <button title="Tema" style={iconBtn} onClick={() => setThemePref(document.documentElement.dataset.theme === "dark" ? "light" : "dark")}><IconTheme /></button>
            <button title="Sair" style={iconBtn} onClick={async () => { try { await api.post("/logout", {}); } catch { /* sessão já morta */ } nav({ to: "/login" }); }}><IconLogout /></button>
          </div>
        </div>
      </aside>
      <main style={{ flex: 1, minWidth: 0, overflow: "auto" }}>
        <Outlet />
      </main>
    </div>
  );
}
